module.exports = __webpack_public_path__ + "media/components/Insulation/QuietZoneCalculator/icons/gallon-6ffc708631e9c298fb277ff32fda3909.svg";